import type { SVGProps } from 'react';

const SvgValueAddedContent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g
      fill="none"
      stroke={props.color}
      strokeLinejoin="round"
      strokeWidth={1.5}
      data-name="Art work"
    >
      <path d="M27.23 12.37a11.41 11.41 0 1 0-19.38 8.16 11.7 11.7 0 0 1 3.51 8.36A2.15 2.15 0 0 0 13.51 31h4.63a2.16 2.16 0 0 0 2.15-2.15 11.68 11.68 0 0 1 3.51-8.36 11.36 11.36 0 0 0 3.43-8.12ZM10.81 24.68h10.05M20.31 27.74h-6.24" />
      <path d="m15.62 5.99-2.16 8.73 4.73-.04-2.59 10.19" />
    </g>
  </svg>
);

export default SvgValueAddedContent;
